export default __webpack_public_path__ + "9ca9ba81e9dcaa12b3a1b141bb39c857.ttf";